import React from 'react'
import LandingStep from 'steps/landing/LandingStep'
import { LockedContent } from 'components/index/LockedContent'
import { UnlockedContent } from 'components/index/UnlockedContent'
import { Breaks } from 'components/index/Breaks'

export const LandingStepContainer = ({
  brk,
  isEmbed,
  stepLocked,
  showRelatedBreaks,
  relatedBreaks,
  onStartClick,
  onAttemptStart,
  onIntersect,
}) => {
  const hasTopNav = brk?.navigationType === 'TOP'
  const wrapperClass = `sponsored-flow-wrapper${hasTopNav ? ' top-navigation' : ''}`

  if (stepLocked) {
    return (
      <div className={wrapperClass}>
        {brk.logoImageId && (
          <div className="upper-logo">
            <img
              src={`${process.env.SITE_ASSET_URL}/${brk.logoImageId}`}
              alt=""
            />
          </div>
        )}
        {showRelatedBreaks ? (
          <UnlockedContent>
            <Breaks breaks={relatedBreaks} />
          </UnlockedContent>
        ) : (
          <LockedContent label="Confirm to Unlock">
            <div
              id="step-0"
              className="step-landing step-position-0"
              data-position="0"
              data-stepid="landing"
              data-steptype="LANDING"
            >
              <div
                className="step-topper step-topper-0 step-topper-landing-new"
                style={{
                  position: 'absolute',
                  marginTop: 'var(--content-desktop-offset-top)',
                }}
                id="step-0-topper"
              />
              <LandingStep
                path={`/break/${brk.permaLink}`}
                brk={brk}
                onAttemptStart={onAttemptStart}
                onStartClick={onStartClick}
                isEmbed={isEmbed}
                hasLogo={!!brk.logoImageId}
              />
            </div>
          </LockedContent>
        )}
      </div>
    )
  }

  return (
    <div className={wrapperClass}>
      {brk.logoImageId && (
        <div className="upper-logo">
          <img
            src={`${process.env.SITE_ASSET_URL}/${brk.logoImageId}`}
            alt=""
          />
        </div>
      )}
      <div
        id="step-0"
        className="step-landing step-position-0"
        data-position="0"
        data-stepid="landing"
        data-steptype="LANDING"
      >
        <div className="step-scroll-position-0" style={{ position: 'relative' }} />
        <div
          className="step-topper step-topper-0 step-topper-landing-new"
          style={{
            position: 'absolute',
            marginTop: 'var(--content-desktop-offset-top)',
          }}
          id="step-0-topper"
        />
        <LandingStep
          path={`/break/${brk.permaLink}`}
          brk={brk}
          onAttemptStart={onAttemptStart}
          onStartClick={onStartClick}
          isEmbed={isEmbed}
          hasLogo={!!brk.logoImageId}
          onIntersect={onIntersect}
        />
      </div>
    </div>
  )
}
